import CardinalDirectionIcon from './CardinalDirectionIcon';

export default CardinalDirectionIcon;
